module.exports = {"id":"dp4_2l3q5","text":"Protecting personal data and privacy","instructions":"Which activity may allow personal data to be reused for AI training?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.2","questionType":"PickOne","random":true,"options":[{"id":"dp4_2l3q5-a1","text":"Sharing public online content","score":3.7},{"id":"dp4_2l3q5-a2","text":"Storing files offline","score":1.3},{"id":"dp4_2l3q5-a3","text":"Using private documents","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.2/l3q5.json
// module id = 1232
// module chunks = 41